import { UnifiedViewerNodeType } from '../types';

import findNearestAncestorByUnifiedViewerType from './findNearestAncestorByUnifiedViewerType';

const findNearestContainerContentGroup = findNearestAncestorByUnifiedViewerType(
  UnifiedViewerNodeType.CONTAINER_CONTENT_GROUP
);

export default findNearestContainerContentGroup;
